import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac64b5ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sf-modal-body" }
const _hoisted_2 = { class: "tw-mb-8" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "account-name" }, "Individual Account"),
  /*#__PURE__*/_createElementVNode("span", { class: "account-price" }, "£10 for 12 months")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "sf-bullets" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Access all word lists, games and activities"),
  /*#__PURE__*/_createElementVNode("li", null, "Track your spelling scores over time"),
  /*#__PURE__*/_createElementVNode("li", null, "Create your own personalised lists"),
  /*#__PURE__*/_createElementVNode("li", null, " Automatically see your 'Tricky Words' - the words you get wrong in tests, and practise these words separately ")
], -1))
const _hoisted_5 = { class: "account-link" }
const _hoisted_6 = { class: "tw-mb-8" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "account-name" }, "School Account"),
  /*#__PURE__*/_createElementVNode("span", { class: "account-price" }, "£30 for 12 months")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "sf-bullets" }, [
  /*#__PURE__*/_createElementVNode("li", null, " Every student has their own personal username and password and can access all spelling lists, games and activities "),
  /*#__PURE__*/_createElementVNode("li", null, " Teachers can schedule differentiated word lists for individual students, or groups, in their class "),
  /*#__PURE__*/_createElementVNode("li", null, " Teachers can see the results whenever their students take a test and can track the progress over time of a student, group or whole class "),
  /*#__PURE__*/_createElementVNode("li", null, " Students earn 'Spelling Points' by playing games and activities and can see their position on the class/school leaderboard (optional) "),
  /*#__PURE__*/_createElementVNode("li", null, " When a student gets a word wrong in a test, it is added to their own personalised 'Tricky Word' list. They can then practise with those words they find tricky until they get them right ")
], -1))
const _hoisted_9 = { class: "account-link" }
const _hoisted_10 = { class: "sf-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, {
    show: _ctx.show,
    size: "md"
  }, {
    tilte: _withCtx(() => [
      _createTextVNode(" Create a Spellingframe Account ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_SfRouterLink, { to: "/register/individual" }, {
              default: _withCtx(() => [
                _createTextVNode(" Create an individual account ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_SfRouterLink, { to: "/register/school" }, {
              default: _withCtx(() => [
                _createTextVNode(" Create an individual account ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_SfRouterLink, {
          to: "/register",
          class: "sf-btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Register ")
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          href: "",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('closed')), ["prevent"])),
          class: "sf-btn-secondary"
        }, " Close ")
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}